<template >
  <div class="main">
    <div class="loginpage">
      <el-row>
        <el-col :span="12">
          <div class="loginpageLeft">
            <el-image :src="require('../../assets/loginLeft.png')"
                      fit="contain"></el-image>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="loginpageRight">
            <div>
              <div class="image-div">
                <el-image class="jiansuanimage"
                          :src="require('../../assets/logo.png')"
                          fit="contain"></el-image>
              </div>
            </div>
            <el-form ref="form"
                     label-position="right"
                     class="form">
              <el-form-item label="账号">
                <el-input class="height"
                          v-model="username"
                          placeholder="请输入手机号或邮箱"></el-input>
              </el-form-item>
              <el-form-item label="密码">
                <el-input v-model="pass"
                          type="password"
                          placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button class="login_button"
                           @click="login"
                           type="primary">登陆</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="bottoms">
      <div><span>岐山县轻工物联互联网有限责任公司版权所有</span>
        <a href="https://beian.miit.gov.cn/">陕ICP备20009921号</a>
      </div>
      <div>
        <el-image class="jiansuanimage"
                  :src="require('../../assets/beiantu.png')"
                  fit="contain"></el-image>
        <a target="_blank"
           href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61032302000042"
           style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src=""
               style="float:left;" />
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">陕公网安备 61032302000042号</p>
        </a>
      </div>
    </div>

    <!-- <div style="width:300px;margin:0 auto; padding:20px 0;">
      <span>岐山县轻工物联互联网有限责任公司版权所有</span>
      <a href="https://beian.miit.gov.cn/">陕ICP备20009921号</a>
      <a target="_blank"
         href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61032302000042"
         style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src=""
             style="float:left;" />
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">陕公网安备 61032302000042号</p>
      </a>
    </div> -->

  </div>
</template>
<script>
import { webLogin } from "../../api/login";
import { enterpriseSel } from "../../api/enterprise";
export default {
  data () {
    return {
      username: "",
      pass: ""
    };
  },
  methods: {
    login () {
      if (this.username.length > 0) {
        if (this.pass.length >= 6) {
          const params = {
            username: this.username,
            pass: this.pass
          };
          webLogin(params)
            .then(res => {
              if (res.role == 3) {
                this.$message.error("请使用《简算js》微信小程序登陆");
                return;
              }
              localStorage.setItem("user_id", res.id);
              localStorage.setItem("token", res.token);
              localStorage.setItem("name", res.name);
              localStorage.setItem("user_name", res.username);
              localStorage.setItem("phone", res.tel);
              let isAdmin = false;
              if (res.role == 0) {
                isAdmin = true;
                localStorage.setItem("isAdmin", isAdmin);
                localStorage.setItem("isLogin", true);
                this.$router.push("/administrators/administrators/list");
              } else {
                isAdmin = false;
                localStorage.setItem("isAdmin", isAdmin);
                this.getEnterpriseSel(res.enterpriseId);
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          this.$message.error("请输入六位以上密码");
        }
      } else {
        this.$message.error("请输入账号");
      }
      console.log();
    },
    getEnterpriseSel (enterpriseId) {
      const params = {
        id: enterpriseId,
        username: localStorage.getItem("user_name"),
        pageNum: 1,
        pageSize: 10
      };
      enterpriseSel(params)
        .then(res => {
          localStorage.setItem("company_id", res.gridData[0].id);
          localStorage.setItem("company_name", res.gridData[0].name);
          localStorage.setItem("province", res.gridData[0].province);
          localStorage.setItem("city", res.gridData[0].city);
          localStorage.setItem("county", res.gridData[0].county);
          localStorage.setItem("isLogin", true);
          this.$router.push("/home/enterprise/personnel/employeeList");
        })
        .catch();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss"  scoped>
.main {
  width: 100%;
  height: 100%;
}
.loginpage {
  width: 100%;
  height: 100%;
  background-color: #f5f6f8;
  display: flex;
  justify-content: center;
  align-items: center;
  .loginpage {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loginpageLeft {
    padding-left: 10px;
  }
  .loginpageRight {
    width: 327px;
    float: right;
    padding-right: 100px;
    .image-div {
      margin: auto;
      width: 100px;
      height: 50px;
      border-radius: 64px 64px 0 0;
      background-color: #ffffff;
      .jiansuanimage {
        width: 55px;
        height: 79px;
        line-height: 79px;
      }
    }
    .form {
      padding: 30px;
      background-color: #ffffff;
      .height {
        height: 28px !important;
        line-height: 28px !important;
      }
      .login_button {
        width: 100%;
      }
    }
  }
}
.bottoms {
  position: absolute;
  bottom: 0px;
  text-align: center;
  width: 100%;
  a {
    margin-left: 10px;
    text-decoration: none;
    color: #39b5fb;
  }
}
</style>
